import { Union, Record } from "../fable_modules/fable-library.3.7.1/Types.js";
import { union_type, bool_type, class_type, record_type, int32_type, string_type } from "../fable_modules/fable-library.3.7.1/Reflection.js";
import { columnDef_header_Z5FD1F5D2, columnDef_id_Z721C83C5, columnDef_accessorFn_77A7E8C8, columnDef_cell_Z1DDB00E5, columnDef_accessorKey_Z721C83C5, columnDef_columns_Z2906D979, columnDef_footer_Z5FD1F5D2, columnDef_header_Z721C83C5 } from "../../Feliz.TanStack.Table/ColumnDef.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library.3.7.1/List.js";
import { createElement } from "react";
import { ColumnPinningPosition, Column_Column_getIsPinned_Z2685F962, Column_Column_getCanPin_Z2685F962, Column_Table_pinColumn, ColumnPinningPosition$reflection } from "../../Feliz.TanStack.Table/Column.fs.js";
import { nonSeeded } from "../fable_modules/fable-library.3.7.1/Random.js";
import { map, iterateIndexed } from "../fable_modules/fable-library.3.7.1/Array.js";
import { Table_getVisibleCells_773C3262, Table_getFooterGroups_Z4395D14A, Table_getHeaderGroups_Z4395D14A, Table_getRightVisibleCells_773C3262, Table_getRightFooterGroups_Z4395D14A, Table_getRightHeaderGroups_Z4395D14A, Table_getCenterVisibleCells_773C3262, Table_getCenterFooterGroups_Z4395D14A, Table_getCenterHeaderGroups_Z4395D14A, Table_getLeftVisibleCells_773C3262, Table_getLeftFooterGroups_Z4395D14A, Table_getLeftHeaderGroups_Z4395D14A, Table_getRowModel_Z4395D14A, Table_getContext_Z78EF7AD2, Table_getContext_315F98D7, Html_flexRender_Z6DEE00B4, Table_getAllLeafColumns_Z4395D14A, Table_init_Z5C3B000E } from "../../Feliz.TanStack.Table/Table.fs.js";
import { tableProps_columns_Z2906D979 } from "../../Feliz.TanStack.Table/TableProps.fs.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.4.0.0-beta-3/cmd.fs.js";
import { Table_getIsSomeColumnsVisible_Z4395D14A, Table_toggleAllColumnsVisible, Column_getIsVisible_Z2685F962, Table_setColumnVisibility } from "../../Feliz.TanStack.Table/Visibility.fs.js";
import { Table_setColumnOrder, Table_resetColumnOrder_Z4395D14A } from "../../Feliz.TanStack.Table/Ordering.fs.js";
import { empty, singleton, append, map as map_1, delay, toList } from "../fable_modules/fable-library.3.7.1/Seq.js";
import { createObj } from "../fable_modules/fable-library.3.7.1/Util.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.67.0/Interop.fs.js";
import { join } from "../fable_modules/fable-library.3.7.1/String.js";
import { useFeliz_React__React_useElmish_Static_B42E862 } from "../fable_modules/Feliz.UseElmish.1.6.0/UseElmish.fs.js";

export class Person extends Record {
    constructor(Firstname, Lastname, Age, Visits, Status, Progress) {
        super();
        this.Firstname = Firstname;
        this.Lastname = Lastname;
        this.Age = (Age | 0);
        this.Visits = (Visits | 0);
        this.Status = Status;
        this.Progress = (Progress | 0);
    }
}

export function Person$reflection() {
    return record_type("Examples.Pinning.Person", [], Person, () => [["Firstname", string_type], ["Lastname", string_type], ["Age", int32_type], ["Visits", int32_type], ["Status", string_type], ["Progress", int32_type]]);
}

export const defaultData = [new Person("Ruthie", "Hirthe", 2, 217, "single", 96), new Person("Domenico", "Swift", 7, 497, "relationship", 70), new Person("Omer", "Zboncak", 13, 667, "complicated", 12), new Person("Esmeralda", "Kihn", 9, 262, "complicated", 6), new Person("Amara", "Bergnaum", 31, 386, "single", 94), new Person("Meredith", "Weber", 32, 509, "complicated", 76), new Person("Kareem", "Bashirian", 33, 802, "relationship", 83), new Person("Rosalyn", "Hoppe", 6, 464, "single", 57), new Person("Marcella", "Powlowski", 21, 758, "single", 10), new Person("Jesus", "Rowe", 39, 738, "complicated", 44), new Person("Astrid", "Pfeffer", 9, 644, "complicated", 76), new Person("Trey", "Keebler", 0, 487, "single", 5), new Person("Verdie", "Mraz", 25, 610, "complicated", 83), new Person("Paige", "Torphy", 22, 63, "single", 26), new Person("Cassandre", "Koepp", 6, 827, "relationship", 11), new Person("Walker", "Farrell", 34, 836, "complicated", 63), new Person("Brenna", "Koss", 25, 150, "complicated", 44), new Person("Carlos", "Buckridge", 10, 766, "complicated", 20), new Person("Francesca", "Tremblay", 9, 245, "relationship", 20), new Person("Nat", "Ryan", 24, 561, "single", 32)];

export const defaultColumns = ofArray([ofArray([columnDef_header_Z721C83C5("Name"), columnDef_footer_Z5FD1F5D2((props) => props.column.id), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Firstname"), columnDef_cell_Z1DDB00E5((info) => info.getValue()), columnDef_footer_Z5FD1F5D2((props_1) => props_1.column.id)]), ofArray([columnDef_accessorFn_77A7E8C8((p) => p.Lastname), columnDef_id_Z721C83C5("Lastname"), columnDef_cell_Z1DDB00E5((info_1) => info_1.getValue()), columnDef_header_Z5FD1F5D2((_arg1) => createElement("span", {
    children: "Last Name",
})), columnDef_footer_Z5FD1F5D2((props_3) => props_3.column.id)])]))]), ofArray([columnDef_header_Z721C83C5("Info"), columnDef_footer_Z5FD1F5D2((props_4) => props_4.column.id), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Age"), columnDef_header_Z5FD1F5D2((_arg2) => "Age"), columnDef_footer_Z5FD1F5D2((props_5) => props_5.column.id)]), ofArray([columnDef_header_Z721C83C5("More Info"), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Visits"), columnDef_header_Z5FD1F5D2((_arg3) => createElement("span", {
    children: "Visits",
})), columnDef_footer_Z5FD1F5D2((props_7) => props_7.column.id)]), ofArray([columnDef_accessorKey_Z721C83C5("Status"), columnDef_header_Z721C83C5("Status"), columnDef_footer_Z5FD1F5D2((props_8) => props_8.column.id)]), ofArray([columnDef_accessorKey_Z721C83C5("Progress"), columnDef_header_Z721C83C5("Profile Progress"), columnDef_footer_Z5FD1F5D2((props_9) => props_9.column.id)])]))])]))])]);

export class State extends Record {
    constructor(Table, IsSplitMode) {
        super();
        this.Table = Table;
        this.IsSplitMode = IsSplitMode;
    }
}

export function State$reflection() {
    return record_type("Examples.Pinning.State", [], State, () => [["Table", class_type("Feliz.TanStack.Table.Types.Table`1", [Person$reflection()])], ["IsSplitMode", bool_type]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AllCheckedChanged", "ColumnChecked", "Reset", "Randomise", "SplitModeChanged", "ToggleColumnPinning"];
    }
}

export function Msg$reflection() {
    return union_type("Examples.Pinning.Msg", [], Msg, () => [[], [["Item", class_type("Feliz.TanStack.Table.Types.Column`1", [Person$reflection()])]], [], [], [], [["Item1", class_type("Feliz.TanStack.Table.Types.Column`1", [Person$reflection()])], ["Item2", ColumnPinningPosition$reflection()]]]);
}

const rand = nonSeeded();

function shuffle(arr) {
    iterateIndexed((i, _arg1) => {
        const a = arr;
        const y = rand.Next2(i, arr.length) | 0;
        const x = i | 0;
        const tmp = a[x];
        a[x] = a[y];
        a[y] = tmp;
    }, arr);
    return arr;
}

export function init() {
    return [new State(Table_init_Z5C3B000E(ofArray([["data", defaultData], tableProps_columns_Z2906D979(defaultColumns)])), false), Cmd_none()];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const c = msg.fields[0];
            return [new State(Table_setColumnVisibility(c, !Column_getIsVisible_Z2685F962(c), state.Table), state.IsSplitMode), Cmd_none()];
        }
        case 2: {
            return [new State(Table_resetColumnOrder_Z4395D14A(state.Table), state.IsSplitMode), Cmd_none()];
        }
        case 3: {
            return [new State(Table_setColumnOrder(shuffle(map((c_1) => c_1.id, Table_getAllLeafColumns_Z4395D14A(state.Table))), state.Table), state.IsSplitMode), Cmd_none()];
        }
        case 4: {
            return [new State(state.Table, !state.IsSplitMode), Cmd_none()];
        }
        case 5: {
            return [new State(Column_Table_pinColumn(msg.fields[1], msg.fields[0], state.Table), state.IsSplitMode), Cmd_none()];
        }
        default: {
            return [new State(Table_toggleAllColumnsVisible(!Table_getIsSomeColumnsVisible_Z4395D14A(state.Table), state.Table), state.IsSplitMode), Cmd_none()];
        }
    }
}

export function view(state, dispatch) {
    let elems_14;
    const table = (headerGroups, footerGroups, visibleCells) => {
        let elems_7;
        let thead;
        const children_2 = toList(delay(() => map_1((headerGroup) => {
            let elems_2;
            return createElement("tr", createObj(ofArray([["key", headerGroup.id], (elems_2 = toList(delay(() => map_1((header) => {
                let elems_1;
                return createElement("th", createObj(ofArray([["key", header.id], ["colSpan", header.colSpan], (elems_1 = toList(delay(() => {
                    let children;
                    return append(singleton((children = toList(delay(() => (header.isPlaceholder ? singleton(null) : singleton(Html_flexRender_Z6DEE00B4(header.column.columnDef.header, Table_getContext_315F98D7(header)))))), createElement("div", {
                        children: Interop_reactApi.Children.toArray(Array.from(children)),
                    }))), delay(() => {
                        let column, elems;
                        return ((!header.isPlaceholder) && Column_Column_getCanPin_Z2685F962(header.column)) ? singleton((column = header.column, createElement("div", createObj(singleton_1((elems = toList(delay(() => {
                            let matchValue;
                            return append((matchValue = Column_Column_getIsPinned_Z2685F962(column), (matchValue.tag === 2) ? singleton(createElement("button", {
                                className: join(" ", ["button", "is-small"]),
                                children: "\u003c=",
                                onClick: (_arg1) => {
                                    dispatch(new Msg(5, column, new ColumnPinningPosition(0)));
                                },
                            })) : ((matchValue.tag === 1) ? singleton(createElement("button", {
                                className: join(" ", ["button", "is-small"]),
                                children: "\u003c=",
                                onClick: (_arg1) => {
                                    dispatch(new Msg(5, column, new ColumnPinningPosition(0)));
                                },
                            })) : singleton(null))), delay(() => {
                                let matchValue_1;
                                return append((matchValue_1 = Column_Column_getIsPinned_Z2685F962(column), (matchValue_1.tag === 0) ? singleton(createElement("button", {
                                    className: join(" ", ["button", "is-small"]),
                                    children: "x",
                                    onClick: (_arg2) => {
                                        dispatch(new Msg(5, column, new ColumnPinningPosition(2)));
                                    },
                                })) : ((matchValue_1.tag === 1) ? singleton(createElement("button", {
                                    className: join(" ", ["button", "is-small"]),
                                    children: "x",
                                    onClick: (_arg2) => {
                                        dispatch(new Msg(5, column, new ColumnPinningPosition(2)));
                                    },
                                })) : singleton(null))), delay(() => {
                                    const matchValue_2 = Column_Column_getIsPinned_Z2685F962(column);
                                    switch (matchValue_2.tag) {
                                        case 2:
                                        case 0: {
                                            return singleton(createElement("button", {
                                                className: join(" ", ["button", "is-small"]),
                                                children: "=\u003e",
                                                onClick: (_arg3) => {
                                                    dispatch(new Msg(5, column, new ColumnPinningPosition(1)));
                                                },
                                            }));
                                        }
                                        default: {
                                            return singleton(null);
                                        }
                                    }
                                }));
                            }));
                        })), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])))))) : empty();
                    }));
                })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
            }, headerGroup.headers))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
        }, headerGroups)));
        thead = createElement("thead", {
            children: Interop_reactApi.Children.toArray(Array.from(children_2)),
        });
        let tbody;
        const children_6 = toList(delay(() => map_1((row) => {
            let elems_3;
            return createElement("tr", createObj(ofArray([["key", row.id], (elems_3 = toList(delay(() => map_1((cell) => {
                const children_4 = singleton_1(Html_flexRender_Z6DEE00B4(cell.column.columnDef.cell, Table_getContext_Z78EF7AD2(cell)));
                return createElement("td", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_4)),
                });
            }, visibleCells(row)))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])));
        }, Table_getRowModel_Z4395D14A(state.Table).rows)));
        tbody = createElement("tbody", {
            children: Interop_reactApi.Children.toArray(Array.from(children_6)),
        });
        let tfoot;
        const children_8 = toList(delay(() => map_1((footerGroup) => {
            let elems_5;
            return createElement("tr", createObj(ofArray([["key", footerGroup.id], (elems_5 = toList(delay(() => map_1((footer) => {
                let elems_4;
                return createElement("th", createObj(ofArray([["key", footer.id], ["colSpan", footer.colSpan], (elems_4 = toList(delay(() => (footer.isPlaceholder ? singleton(null) : singleton(Html_flexRender_Z6DEE00B4(footer.column.columnDef.header, Table_getContext_315F98D7(footer)))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
            }, footerGroup.headers))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])])));
        }, footerGroups)));
        tfoot = createElement("tfoot", {
            children: Interop_reactApi.Children.toArray(Array.from(children_8)),
        });
        return createElement("div", createObj(ofArray([["className", join(" ", ["p-2"])], (elems_7 = [createElement("table", {
            children: Interop_reactApi.Children.toArray([thead, tbody, tfoot]),
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])])));
    };
    const inputCheck = (props_16) => {
        let elems_9, elems_8;
        return createElement("div", createObj(ofArray([["className", join(" ", ["field"])], (elems_9 = [createElement("label", createObj(ofArray([["className", "checkbox"], (elems_8 = [createElement("input", {
            className: join(" ", ["pl-2"]),
            type: "checkbox",
            checked: props_16.isChecked,
            onChange: (ev) => {
                const _arg4 = ev.target.checked;
                props_16.onChange();
            },
        }), ` ${props_16.text}`], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])])));
    };
    return createElement("div", createObj(singleton_1((elems_14 = toList(delay(() => {
        let elems_12, elems_10, elems_11;
        return append(singleton(createElement("div", createObj(ofArray([["className", join(" ", ["field"])], (elems_12 = [inputCheck({
            id: "all",
            isChecked: Table_getIsSomeColumnsVisible_Z4395D14A(state.Table),
            onChange: () => {
                dispatch(new Msg(0));
            },
            text: "Toggle All",
        }), createElement("div", createObj(singleton_1((elems_10 = toList(delay(() => map_1((column_1) => {
            let id_1, text_1;
            return inputCheck((id_1 = column_1.id, (text_1 = column_1.id, {
                id: id_1,
                isChecked: Column_getIsVisible_Z2685F962(column_1),
                onChange: () => {
                    dispatch(new Msg(1, column_1));
                },
                text: text_1,
            })));
        }, Table_getAllLeafColumns_Z4395D14A(state.Table)))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_10))])))), createElement("div", createObj(ofArray([["className", join(" ", ["pt-2"])], (elems_11 = [createElement("button", {
            className: join(" ", ["button"]),
            children: "Reset",
            onClick: (_arg5) => {
                dispatch(new Msg(2));
            },
        }), createElement("button", {
            className: join(" ", ["button"]),
            children: "Randomise",
            onClick: (_arg6) => {
                dispatch(new Msg(3));
            },
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_11))])]))), inputCheck({
            id: "split",
            isChecked: state.IsSplitMode,
            onChange: () => {
                dispatch(new Msg(4));
            },
            text: "Split Mode",
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_12))])])))), delay(() => {
            let elems_13;
            return state.IsSplitMode ? singleton(createElement("div", createObj(ofArray([["className", join(" ", ["columns"])], (elems_13 = [table(Table_getLeftHeaderGroups_Z4395D14A(state.Table), Table_getLeftFooterGroups_Z4395D14A(state.Table), Table_getLeftVisibleCells_773C3262), table(Table_getCenterHeaderGroups_Z4395D14A(state.Table), Table_getCenterFooterGroups_Z4395D14A(state.Table), Table_getCenterVisibleCells_773C3262), table(Table_getRightHeaderGroups_Z4395D14A(state.Table), Table_getRightFooterGroups_Z4395D14A(state.Table), Table_getRightVisibleCells_773C3262)], ["children", Interop_reactApi.Children.toArray(Array.from(elems_13))])])))) : singleton(table(Table_getHeaderGroups_Z4395D14A(state.Table), Table_getFooterGroups_Z4395D14A(state.Table), Table_getVisibleCells_773C3262));
        }));
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_14))]))));
}

export function Component() {
    const patternInput = useFeliz_React__React_useElmish_Static_B42E862(init, update);
    return view(patternInput[0], patternInput[1]);
}

//# sourceMappingURL=Pinning.fs.js.map
